/* eslint-disable import/prefer-default-export */
import { Incident } from "../status/data/monitoring-service";
import { LongRunningTaskModel } from "./types";

const buildDescription = (task: LongRunningTaskModel) => {
  return task.tableInformation?.name
    ? `Table: ${task.tableInformation.name}`
    : "Task has exceeded the expected run time.";
};

export const mapLongRunningTasksToIncidents = (
  tasks: LongRunningTaskModel[] = [],
): Incident[] => {
  const now = new Date().toISOString();

  return tasks.map((task) => ({
    guid: task.task.id,
    title: task.task.description || "Long running task",
    link: `#${task.task.id}`,
    description: buildDescription(task),
    publishedDate: task.task.dateCompleted || task.task.dateRequested || now,
    isResolved: Boolean(task.task.dateCompleted),
    monitorName: task.tableInformation?.name || "Unknown table",
    incidentType: task.task.dateCompleted ? "warning" : "critical",
    resolvedDate: task.task.dateCompleted || null,
    firstDetectedDate: task.task.dateRequested || now,
    taskStatus: task.task.status,
    runTime: task.task.runTime,
    lastEventLabel: "Date requested",
  }));
};
